<footer class="footer ">
  <div class="container-fluid">

    <div class="copyright pull-center">
      &copy;
      {{test | date: 'yyyy'}}, Powered by
      <a href="https://inadvancecg.com/" target="_blank">InAdvance</a>.
      {{ versionNumber }}
    </div>
  </div>
</footer>
